import React, { useContext, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TimeContext } from '../provider/time-provider';
import { useCol, useDoc } from '../hooks';
import _ from 'lodash';
import { Stack } from '@mui/material';

export const Timeline = ({ fieldId }) => {
    const { days, times } = useContext(TimeContext);
    const { data } = useCol(`fields/${fieldId}/timeSchedule`);
    const { data: colors } = useDoc('configurations/colors');

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell
                            sx={{ borderRight: '1px solid rgba(0, 0, 0, 0.2)' }}
                        >
                            Name
                        </TableCell>
                        {times.map((time) => (
                            <TableCell align="right">{time}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {days.map((day) => {
                        const indexof = _.findIndex(
                            data,
                            (cur) => cur.id === day.date
                        );
                        const dayData = indexof !== -1 ? data[indexof] : null;

                        return (
                            <TableRow key={day.longName}>
                                <TableCell
                                    sx={{
                                        border: '1px solid rgba(0, 0, 0, 0.2)',
                                    }}
                                    align="right"
                                >
                                    {day.longName}
                                </TableCell>
                                {times.map((time) => (
                                    <TimeBooked
                                        dayData={dayData}
                                        colors={colors}
                                        time={time}
                                    />
                                ))}
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

const TimeBooked = ({ dayData, colors, time }) => {
    const [clicked, setClicked] = useState(false);
    if (dayData === null || dayData === undefined) return <TableCell />;

    if (dayData.half === null || dayData.half === undefined) {
    } else if (dayData.half[time] !== undefined)
        return (
            <Stack>
                <Cell
                    text={clicked ? 'Устгах' : dayData.half[time][0]}
                    bg={clicked ? 'red' : colors[dayData.half[time][0]]}
                    onClick={() => setClicked(true)}
                />
                {dayData.half[time][1] && (
                    <Cell
                        text={clicked ? 'Устгах' : dayData.half[time][1]}
                        bg={clicked ? 'red' : colors[dayData.half[time][1]]}
                        onClick={() => setClicked(true)}
                    />
                )}
            </Stack>
        );

    if (dayData.full === null || dayData.full === undefined) {
    } else if (dayData.full[time] !== undefined)
        return (
            <Cell
                text={clicked ? 'Устгах' : dayData.full[time]}
                bg={clicked ? 'red' : colors[dayData.full[time]]}
                onClick={() => setClicked(true)}
            />
        );

    return <TableCell />;
};

const Cell = ({ text, bg, onClick }) => {
    return (
        <TableCell
            onClick={onClick}
            sx={{
                background: bg,
                color: 'white',
            }}
        >
            {text}
        </TableCell>
    );
};

const DeleteButton = () => {};
